import { render, staticRenderFns } from "./AbsenceJustifiedWidget.vue?vue&type=template&id=153ccf0c&scoped=true&"
import script from "./AbsenceJustifiedWidget.vue?vue&type=script&lang=js&"
export * from "./AbsenceJustifiedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153ccf0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('153ccf0c')) {
      api.createRecord('153ccf0c', component.options)
    } else {
      api.reload('153ccf0c', component.options)
    }
    module.hot.accept("./AbsenceJustifiedWidget.vue?vue&type=template&id=153ccf0c&scoped=true&", function () {
      api.rerender('153ccf0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/absences/widgets/AbsenceJustifiedWidget.vue"
export default component.exports